import axios from 'axios';
import * as Config from '../../config';

const state = {
};

const actions = {

  load_Expirations({ commit, dispatch }) {
    return new Promise((resolve, reject) => {

      axios.get(Config.apiPath + 'expiration/list/all')
        .then(
          response => {
            resolve(response.data);

          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  new_Expiration({ commit, dispatch }, form) {

    return new Promise((resolve, reject) => {
      axios.post(Config.apiPath + 'expiration/store', form)
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  changeStatus_Expiration({ commit, dispatch }, form) {

    return new Promise((resolve, reject) => {
      axios.put(Config.apiPath + 'expiration/change/status/' + form.id + '/' + form.status)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  dateCurrent() {

    return new Promise((resolve, reject) => {
      axios.put(Config.apiPath + 'expiration/date/current')
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

};

const mutations = {


};

export default {
    state,
    actions,
    mutations
};
